import request from "@/utils/request";

// 角色列表
export function queryRoleList(data) {
  return request({
    url: "/approvalConfig/getRoleList",
    method: "post",
    data,
  });
}

// 查询角色
export function queryRole(data) {
  return request({
    url: "/approvalConfig/page",
    method: "post",
    data,
  });
}

// 修改角色
export function updateRole(data) {
  return request({
    url: "/approvalConfig/update",
    method: "post",
    data,
  });
}
